/*
  Ouverture des menus déroulants de l'en-tête AU SURVOL.

  Dawn ne les ouvre qu'au clic : ses entrées de menu sont des `<summary>`, et un
  `<details>` ne s'ouvre pas en CSS. Le survol demande donc un peu de script.

  Trois précautions :

  - **Souris seulement.** Sur un écran tactile, `mouseenter` se déclenche au
    premier appui : le panneau s'ouvrirait puis se refermerait aussitôt. On ne
    branche rien si le pointeur n'est pas fin.
  - **Un délai à la sortie.** Entre l'entrée de menu et son panneau, il y a
    quelques pixels de vide ; sans délai, une souris qui descend en diagonale
    referme le menu en chemin.
  - **On passe par la propriété `open`, pas par un clic simulé.** Ouvrir
    déclenche l'événement `toggle`, que `details-disclosure.js` écoute déjà pour
    caler le panneau sous l'en-tête. Un clic simulé, lui, refermerait le menu
    une fois sur deux selon son état.
*/

(() => {
  const pointeurFin = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!pointeurFin.matches) return;

  // Délai avant fermeture, en millisecondes. Porté de 180 à 400 le 2026-08-18 :
  // à 180, le menu se refermait avant qu'on ait eu le temps de descendre
  // dedans, ou dès qu'on sortait d'un cheveu en visant une entrée.
  // Au-delà d'une demi-seconde, l'effet s'inverse : le panneau paraît collé et
  // reste ouvert alors qu'on regarde déjà ailleurs.
  const DELAI_FERMETURE = 400;
  let fermetureEnAttente = null;

  const volets = () =>
    document.querySelectorAll('.header__inline-menu header-menu > details');

  function ouvrir(details) {
    if (details.open) return;
    volets().forEach((autre) => {
      if (autre !== details) fermer(autre);
    });
    details.open = true;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  function fermer(details) {
    if (!details.open) return;
    details.open = false;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  function brancher(details) {
    if (details.dataset.survolBranche === 'oui') return;
    details.dataset.survolBranche = 'oui';

    details.addEventListener('mouseenter', () => {
      clearTimeout(fermetureEnAttente);
      ouvrir(details);
    });

    details.addEventListener('mouseleave', () => {
      clearTimeout(fermetureEnAttente);
      fermetureEnAttente = setTimeout(() => fermer(details), DELAI_FERMETURE);
    });
  }

  function brancherTout() {
    volets().forEach(brancher);
  }

  /*
    Une entrée de menu sans sous-menu doit refermer le panneau voisin : sinon,
    en glissant le long de la barre, le panneau resterait ouvert sous une
    rubrique qui n'est pas la sienne.
  */
  function brancherEntreesSimples() {
    document
      .querySelectorAll('.header__inline-menu > ul > li > a')
      .forEach((lien) => {
        if (lien.dataset.survolBranche === 'oui') return;
        lien.dataset.survolBranche = 'oui';
        lien.addEventListener('mouseenter', () => {
          clearTimeout(fermetureEnAttente);
          volets().forEach(fermer);
        });
      });
  }

  function tout() {
    brancherTout();
    brancherEntreesSimples();
  }

  document.addEventListener('DOMContentLoaded', tout);
  tout();

  /*
    L'éditeur de thème remplace l'en-tête entier à chaque modification : les
    écouteurs posés sur l'ancien balisage partent avec lui.
  */
  document.addEventListener('shopify:section:load', tout);
})();
